import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Todo = {
  id: number | string;
  value: string;
};

type UpdatePayload = {
  id: number | string;
  value: string;
};

const initialState: Todo[] = [];

const todoSlice = createSlice({
  name: 'todo',
  initialState,
  reducers: {
    addTodo: (state, action: PayloadAction<Todo>) => {
      if (!action.payload) return;

      state.push(action.payload);
    },

    updateTodo: (state, action: PayloadAction<UpdatePayload>) => {
      const newTodos = state.map((todo) => {
        if (todo.id === action.payload.id) {
          return {
            ...todo,
            value: action.payload.value,
          };
        }
        return todo;
      });

      return newTodos;
    },

    deleteTodo: (state, action: PayloadAction<number | string>) => {
      const FilteredTodos = state.filter((todo) => todo.id !== action.payload);
      return FilteredTodos;
    },
  },
});

export const { addTodo, updateTodo, deleteTodo } = todoSlice.actions;

export default todoSlice.reducer;
